// use this method
document.addEventListener('crPickupActivated', function (e) { 
  console.log('Update', '')
    
	jqCR('body').on('click', '[name="checkout"]', function(e){

    if (jqCR('#pickup-details').length) {
   		e.preventDefault();
 
      var myForm = jqCR('#pickup-details').closest('form')
	    
	    var pickupFirstName = '';
	    var pickupLastName = '';
      	var pickupNumber = jqCR('#pickup-number').val();

	  	var shippingInformation = storePickup.shippingInformation + 'test'
	    //storePickup.updateFormActionWithShippingInformation();
	    
	    var action = myForm.attr('action');      	      
	    if (action == '/cart') {
        	action = '/checkout?'      	
      	}
		//console.log(action)      
	    var pivot = action.replace(/checkout\[email_or_phone\]=(.*?)\&/, '');
	  	shippingInformation = pivot + "&checkout[email_or_phone]=" + pickupNumber;
	  	
	   	  
	  	myForm.attr('action', shippingInformation)  

       if (myForm.valid()) {
          myForm.submit()      	
        }
      }else{
      
      }
  })
})